import React from 'react';
import {
  Input,
  Typography,
  Divider,
  Tag,
  AutoComplete,
  Button,
  Select,
  Dropdown,
  Menu,
  Icon,
} from 'antd';
import Context from '../Container/Context';
import api from '../../../config/api';
import { useDidMount, useModel } from '../../use';
import { strings, asserts, network, generators } from '../../../utils';
import { message } from '../../biz';
import { clone } from 'ramda';
import { setSerachLog, searchEventType } from '../../../utils/addLog';

const { Search } = Input;
const { Text } = Typography;
const { generatorArray } = generators;

const initialState = {
  options: [],
};
const updateState = (state, payload) => ({ ...state, ...payload });
const effects = {
  query: async ({ payload, dispatch }) => {
    const response = await network({
      url: api.home.shortcut,
      method: 'get',
    });
    if (response.success) {
      if (!response.data.success) {
        message.error(response.data.message);
      }
      dispatch('updateState')({ options: generatorArray(response.data.data) });
    }
  },
};
const searchCodeTypeMap = {
  searchValue: '全部',
  itemCode: '项目号',
  uitemCode: '自定义编码',
  itemCode20: '二十码',
};
const placeholderMap = {
  searchValue: '关键字请隔开 例:304 933 8*20 中文描述',
  itemCode: '请输入项目号',
  uitemCode: '请输入自定义编码',
  itemCode20: '请输入二十码',
};
export default ({ isShow }) => {
  const { history } = React.useContext(Context);
  const [searchValue, setSearchValue] = React.useState(undefined);
  const { dispatch, state } = useModel({ state: initialState, reducers: { updateState }, effects });
  let { options, searchHistory } = state;
  const [searchCodeType, setSearchCodeType] = React.useState('searchValue'); //全部/项目号/自定义编码
  const [searchDropVisible, setSearchDropVisible] = React.useState(false);

  const judgementFn = (location) => {
    if (location.pathname === '/search') {
      const { search, searchCodeType } = strings.fromQs();
      if (Object.keys(searchCodeTypeMap).includes(searchCodeType)) {
        setSearchCodeType(searchCodeType);
      }
      if (asserts.isExist(search)) setSearchValue(search);
    }
  };

  useDidMount(() => {
    judgementFn(history.location);
    dispatch('query')();
    const storage = window.localStorage.getItem('dm-search-history');
    dispatch('updateState')({ searchHistory: (storage && JSON.parse(storage)) || [] });
  });

  React.useEffect(() => {
    const unlisten = history.listen((location) => {
      judgementFn(location);
    });
    return () => {
      unlisten();
    };
  });

  const handleClick = (item) => {
    const { keyword, keywordLink1, keywordLink2, keywordLink3, keywordLink4 } = item;
    setSerachLog(searchEventType.hotWords, '');
    if (asserts.isExist(keywordLink1)) {
      history.push(
        `/search?scatId=${keywordLink1}&pcatId=${keywordLink2}&catCode=${keywordLink3}&ibsrp3Dl01=${keywordLink4}&quickLink=true`,
      );
    } else {
      setSearchValue(keyword);
      history.push(`/search?searchCodeType=searchValue&search=${keyword}`);
    }
  };
  const historyOptions = searchHistory && Array.from(new Set(searchHistory.map((i) => i.keyword)));
  return (
    <section className="header-search-wrapper">
      <div
        style={{
          display: 'flex',
          border: '1px solid #2559B8',
          alignItems: 'center',
          borderRadius: 4,
        }}
      >
        <Dropdown
          onVisibleChange={(visible) => {
            setSearchDropVisible(visible);
          }}
          overlay={
            <Menu
              onClick={({ key }) => {
                setSearchDropVisible(false);
                setSearchCodeType(key);
              }}
            >
              {Object.entries(searchCodeTypeMap).map((item) => (
                <Menu.Item key={item[0]} style={{ textAlign: 'center' }}>
                  <div>{item[1]}</div>
                </Menu.Item>
              ))}
            </Menu>
          }
        >
          <div
            style={{
              display: 'inline-block',
              width: '110px',
              textAlign: 'center',
              alignSelf: 'stretch',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <span style={{ color: '#5B7FB4', marginRight: '10px' }}>
              {searchCodeTypeMap[searchCodeType]}
            </span>
            {searchDropVisible ? (
              <Icon type="caret-up" theme="filled" />
            ) : (
              <Icon type="caret-down" theme="filled" />
            )}
          </div>
        </Dropdown>
        <AutoComplete
          dataSource={historyOptions}
          style={{ flex: 1 }}
          defaultActiveFirstOption={false}
          value={searchValue}
          onChange={(val) => {
            setSearchValue(val);
          }}
        >
          <Input
            style={{
              width: '100%',
              borderWidth: 0,
              outline: 'none',
              boxShadow: 'none',
              borderRadius: 0,
              borderRight: 'none',
            }}
            placeholder={placeholderMap[searchCodeType]}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                if (searchValue && searchValue.length > 1) {
                  const historyCache = clone(searchHistory);
                  historyCache.unshift({ _t: new Date().getTime(), keyword: searchValue });
                  dispatch('updateState')({ searchHistory: historyCache });
                  window.localStorage.setItem('dm-search-history', JSON.stringify(historyCache));
                  setSerachLog(searchEventType.keyWords, '');
                  history.push(
                    `/search?searchCodeType=${searchCodeType}&search=${
                      searchValue === 'undefined' ? '' : searchValue
                    }`,
                  );
                } else {
                  message.info('请至少输入两个字符');
                }
              }
            }}
            // enterButton={null}
            // value={searchValue}
            // onChange={(e) => {
            //   setSearchValue(e.target.value);
            // }}
            // onSearch={(value) => {
            //   if (value) {
            //     const historyCache = clone(searchHistory);
            //     historyCache.unshift({ _t: new Date().getTime(), keyword: value });
            //     // 避免数量太多导致样式问题,暂时显示最近8条
            //     // if (historyCache.length > 8) {
            //     //   historyCache.splice(8);
            //     // }
            //     dispatch('updateState')({ searchHistory: historyCache });
            //     window.localStorage.setItem('dm-search-history', JSON.stringify(historyCache));
            //   }
            //   history.push(`/search?search=${value}`);
            // }}
          />
        </AutoComplete>
        <Button
          type="primary"
          style={{ width: 46, height: 32, borderRadius: 0, height: '36px' }}
          onClick={() => {
            if (searchValue && searchValue.length > 1) {
              const historyCache = clone(searchHistory);
              historyCache.unshift({ _t: new Date().getTime(), keyword: searchValue });
              dispatch('updateState')({ searchHistory: historyCache });
              setSerachLog(searchEventType.keyWords, '');
              window.localStorage.setItem('dm-search-history', JSON.stringify(historyCache));
              history.push(
                `/search?searchCodeType=${searchCodeType}&search=${
                  searchValue === 'undefined' ? '' : searchValue
                }`,
              );
            } else {
              message.info('请至少输入两个字符');
            }
          }}
        >
          <svg
            style={{ verticalAlign: 'middle' }}
            viewBox="64 64 896 896"
            focusable="false"
            className=""
            data-icon="search"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>
          </svg>
        </Button>
      </div>
      {options.map((item, index) => {
        if (isShow) {
          return (
            <React.Fragment key={item.id}>
              <Text className="hover-link quick-link-text" onClick={() => handleClick(item)}>
                {item.keyword}
              </Text>
              {index === options.length - 1 ? null : <Divider type="vertical" />}
            </React.Fragment>
          );
        }
      })}

      {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
      {/* {searchHistory &&
        searchHistory.map((item) => {
          return (
            <Tag
              style={{ marginBottom: 2 }}
              closable
              visible={true} // 不加这个的话默认的组件关闭有bug
              onClose={(e) => {
                const newHistroy = clone(searchHistory).filter((i) => i.keyword !== item.keyword);
                dispatch('updateState')({ searchHistory: newHistroy });
                window.localStorage.setItem('dm-search-history', JSON.stringify(newHistroy));
              }}
              onClick={(e) => {
                history.push(`/search?search=${item.keyword}`);
              }}
            >
              {item.keyword}
            </Tag>
          );
        })} */}
    </section>
  );
};
